import React from 'react';
import { useSelector } from 'react-redux';

export default function useLoaderSelector() {
  const isPageLoading = useSelector((state) => state.Loader.loader);
  return { isPageLoading };
}
